var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1752130620605,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1657,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M841.955556 56.888889H182.044444C113.777778 56.888889 56.888889 113.777778 56.888889 182.044444v659.911112C56.888889 910.222222 113.777778 967.111111 182.044444 967.111111h659.911112c68.266667 0 125.155556-56.888889 125.155555-125.155555V182.044444C967.111111 113.777778 910.222222 56.888889 841.955556 56.888889z",
    fill: "#d81e06",
    "p-id": 1658
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnd);
export default __webpack_public_path__ + "static/media/end.1860c533413761bc61c39db61490d8c0.svg";
export { ForwardRef as ReactComponent };